"use client";

export interface QueueTrack {
  title: string;
  artist: string;
  album_art?: string;
  uri?: string;
  pending?: boolean;
}

interface Props {
  tracks: QueueTrack[];
  onRefresh?: () => void;
}

export default function Queue({ tracks, onRefresh }: Props) {
  if (!tracks.length) return null;

  return (
    <div className="w-full space-y-2">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-[var(--muted)] uppercase tracking-wider">
          Up Next
        </h2>
        {onRefresh && (
          <button
            onClick={onRefresh}
            className="text-xs text-[var(--muted)] hover:text-[var(--foreground)] transition-colors px-2 py-1"
            title="Refresh queue"
          >
            ↻
          </button>
        )}
      </div>
      <div className="space-y-1">
        {tracks.map((t, i) => (
          <div
            key={t.uri ?? `${t.title}-${i}`}
            className="flex items-center gap-3 p-2 rounded-lg"
            style={t.pending ? { background: "rgba(193,74,26,0.08)" } : undefined}
          >
            <span className="text-xs text-[var(--muted)] w-5 text-right">{i + 1}</span>
            {t.album_art ? (
              <img src={t.album_art} alt="" className="w-8 h-8 rounded" />
            ) : (
              <div className="w-8 h-8 rounded bg-[var(--border)]" />
            )}
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <p className="truncate text-sm">{t.title}</p>
                {t.pending && (
                  <span
                    className="text-[10px] uppercase tracking-wider shrink-0"
                    style={{ color: "var(--accent)" }}
                  >
                    just added
                  </span>
                )}
              </div>
              <p className="truncate text-xs text-[var(--muted)]">{t.artist}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
